//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mixinProps } from '@/components/mixin.js'
import { debuglog } from 'util'
export default {
  name: 'Checkbox',
  mixins: [mixinProps],
  props: {
    value: {
      type: [String, Number, Boolean],
      default() {
        return undefined
      },
    },
  },
  data() {
    return {
      isSingle: true,
      singleValue: undefined,
    }
  },
  computed: {
    checked() {
      return !this.isSingle
        ? this.$parent.values.includes(this.value)
        : !!this.value
    },
    dynamicClass() {
      return {
        'my-checkbox-checked': this.checked,
        'my-checkbox-disabled': this.disabled,
      }
    },
  },
  mounted() {
    this.isSingle =
      this.$parent && !~this.$parent.$el.className.indexOf('my-checkbox-group')
    if (this.isSingle) {
      this.singleValue = this.value
      if (this.$el.querySelector('input')) {
        this.$el.querySelector('input').checked = !!this.singleValue
      }
    }
  },
  methods: {
    change(e) {
      if (this.disabled) {
        this.$emit('disabled-click')
        return
      }
      if (this.isSingle) {
        this.singleValue = !this.singleValue
        this.$emit('input', e.target.checked ? this.singleValue : undefined)
        return
      }
      try {
        this.$parent.change({
          value: this.value,
          checked: !this.checked,
        })
      } catch (error) {
        console.error(error)
      }
    },
  },
}
